const initialState = {
    agGridDefaultColDef: [],
    agGridRowData: [],
    agGridContextMenuItems: [],
    totalRowCount: -1,
    tableName: '',
    explorerViews: [],
    virtualColumns: [],
    filesFromServer: [],
    filesFromContainer: [],
    linkedGcDataArray: {}
};


export default initialState;

